// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2QbPN","amount":"Amount_amount__3tNCA","tip":"Amount_tip__3eXEw","tipHeader":"Amount_tipHeader__1TaKK","tipsWrap":"Amount_tipsWrap__34QnO"};